import {instance} from './../../_axios'

export default class AttendanceCounter{
    static fetchStat(){
        return instance.get('/attendances/stat')
    }
}
